/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import moment from 'moment-timezone';
import AuthService from 'cio/services/auth';
import MasqService from 'cio/services/masq';
import BillingService from 'cio/services/billing';
import AccountService from 'cio/services/account';
import { action } from '@ember/object';
import AnalyticsService from 'cio/services/analytics';

const TRIAL_EXPIRING_SOON_DAYS = 10;
const TRIAL_ALMOST_EXPIRED_DAYS = 3;

export interface TrialIndicatorSignature {
  Element: HTMLDivElement;
}

export default class TrialIndicator extends Component<TrialIndicatorSignature> {
  @service auth!: AuthService;
  @service masq!: MasqService;
  @service account!: AccountService;
  @service billing!: BillingService;
  @service analytics!: AnalyticsService;

  get isPlanTrial(): boolean {
    // suspendTrialAt on the account will have priority over 'journeys trials' from planFeatures attribute.
    return this.account.current.suspendTrialAt != null;
  }

  get expiresAt(): number | null {
    return this.isPlanTrial ? this.account.current.suspendTrialAt : this.account.planFeatures.messaging.expiresAt;
  }

  get daysLeftInTrial(): number {
    if (this.expiresAt == null) {
      return 0;
    }
    return moment.unix(this.expiresAt).diff(moment(), 'day');
  }

  get trialEnded() {
    return this.isPlanTrial ? this.billing.trialExpired : this.account.planFeatures.messaging.expired;
  }

  get buttonColor() {
    if (this.daysLeftInTrial >= TRIAL_EXPIRING_SOON_DAYS) {
      return 'fly-btn--primary';
    }
    if (this.daysLeftInTrial < TRIAL_EXPIRING_SOON_DAYS && this.daysLeftInTrial >= TRIAL_ALMOST_EXPIRED_DAYS) {
      return 'bg-yellow-500 text-black';
    }
    if (this.daysLeftInTrial < TRIAL_ALMOST_EXPIRED_DAYS && this.daysLeftInTrial >= 0) {
      return 'bg-red-500 text-white';
    }
    return;
  }

  get upgradeNowRoutePath() {
    if (this.billing.pinnedPlan != null) {
      return 'settings.billing.checkout';
    }
    return 'settings.billing.available-plans.journeys';
  }

  @action
  trackUpgradeClicked() {
    return this.analytics.track('onboarding', 'upgrade_clicked', {
      account_id: this.account?.current?.id,
    });
  }

  @action
  finalFormatter(timestampAsMoment: moment.Moment) {
    return timestampAsMoment.fromNow(true);
  }
}
